import modalElement from "../../modals/modal";
import ModalBase from "../../abstracts/modalBase";
import PtFlagOpt from "./ptFlagOp";
import FrFlagOpt from "./frFlagOp";
import SpFlagOpt from "./spFlagOp";
import EnFlagOpt from "./enFlagOp";

export default class ModalSelectLanguage extends ModalBase {
    private static idModal = "modal-language";
    private static dimension = "modal-mediun";
    protected static modalTitle = "Escolha seu Idioma";
    private static elementToRender = modalElement(
        ModalSelectLanguage.idModal,
        ModalSelectLanguage.dimension,
        ModalSelectLanguage.modalTitle
    );
    

    constructor(protected container){
        super(
            ModalSelectLanguage.modalTitle,
            container,
            ModalSelectLanguage.idModal,
            ModalSelectLanguage.elementToRender
        );
    }

    public loadBody(cb:()=>void){
        const flagToLoad = [
            new PtFlagOpt(this.modalBody).loadFlag(),
            new FrFlagOpt(this.modalBody).loadFlag(),
            new SpFlagOpt(this.modalBody).loadFlag(),
            new EnFlagOpt(this.modalBody).loadFlag()
        ];

        flagToLoad.forEach(flagOption=>{
            flagOption.addEventListener("click",cb);
        });
        
    }
}